"use client"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactNode, useState } from "react"

export function QueryProvider({ children, client }: { children: ReactNode; client?: QueryClient }) {
  // `client` prop: the SPA host injects its shared QueryClient so route guards
  // (beforeLoad → ensureQueryData) and components share one cache. Absent →
  // own instance, exactly as before (used by the Next.js shell).
  const [queryClient] = useState(
    () =>
      client ??
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 phút coi là fresh
            gcTime: 30 * 60 * 1000, // giữ cache 30 phút (previously cacheTime)
            refetchOnWindowFocus: false,
            // Không retry lỗi auth (401/403) — retry chỉ gấp đôi request chắc chắn fail.
            retry: (failureCount, error) => {
              const status = (error as { status?: number } | null)?.status
              if (status === 401 || status === 403) return false
              return failureCount < 1
            },
          },
        },
      })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
